// extracted by mini-css-extract-plugin
export default {"container":"AssetRenderer_container__NmQzI","assetLogo":"AssetRenderer_assetLogo__FFCdK","asset":"AssetRenderer_asset__BO8XK","longName":"AssetRenderer_longName__Oo6T6"};